import { backendFetch } from '../../../backend/backend';
import React, { useEffect, useState, Fragment } from 'react';
import { TableRow } from '@mui/material';
import { TSCell, TSTable } from '../../ui/TableStructure';

const StatsSeasons=()=>{
    const NUM_LAST_WINNERS=5;
    const [seasons, setSeasons]=useState([]);
    const [playersList, setPlayersList]=useState([]);
    const [leagueWinsPerPlayer, setLeagueWinsPerPlayer]=useState([]);
    const [leagueWinners, setLeagueWinners]=useState([]);

    useEffect(()=>{
        const fetchData=async ()=>{
            const seasons=(await backendFetch('/seasons')).filter((s)=>s.status==='past').map((s)=>s.startDate);
            setSeasons(seasons);
            const players=await backendFetch(`players`);
            setPlayersList(players);
        }
        fetchData();
    },[])

    useEffect(()=>{
        const leagues=[];
        const leagueWins={};
        const leagueWinners=[];
        const fetchData=async ()=>{
            if (seasons.length>0 && playersList.length>0) {
                await playersList.forEach(async (player)=>{
                    leagueWins[player.name]=0;
                });
                let numWinners=0;
                for (const season of seasons) {
                    const league=await backendFetch(`league?season=${season}`);
                    leagues.push(league);
                    leagueWins[league[0].player]+=1;
                    if (numWinners<NUM_LAST_WINNERS) {
                        leagueWinners.push([season,league[0].player]);
                        numWinners++;
                    }
                }
                setLeagueWinners(leagueWinners);
                let leagueWinsArray=[];
                for (var player in leagueWins) {
                    leagueWinsArray.push([player,leagueWins[player]]);
                }
                leagueWinsArray.sort((a,b)=>b[1]-a[1]);
                setLeagueWinsPerPlayer(leagueWinsArray);
            }
        }
        fetchData();
    },[seasons, playersList])

    return(
        <Fragment>
            <TSTable title="Total Championships" headings={["Player","Wins"]}>
                {leagueWinsPerPlayer.map((lw)=>
                <TableRow key={lw[0]}>
                    <TSCell>{lw[0]}</TSCell>
                    <TSCell>{lw[1]}</TSCell>
                </TableRow>)}
            </TSTable>
            <TSTable    title={"Last "+NUM_LAST_WINNERS+" Champions"}
                        headings={["Season","Player"]}>
                {leagueWinners.map((lw)=>
                <TableRow key={lw[0]}>
                    <TSCell>{lw[0]}</TSCell>
                    <TSCell>{lw[1]}</TSCell>
                </TableRow>)}
            </TSTable>
        </Fragment>
    );
}

export default StatsSeasons;

